// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"86111f36","955":"e0033326","977":"d75cf9f7"}[chunkId] + ".chunk.js";
};